// extracted by mini-css-extract-plugin
export default {"a":"styles_a__P4Mzs","link_blue":"styles_link_blue__qB+b9"};